// What the Client Interaction page and its sections share: the colours, the layout of the bordered four-column
// sections, the Yes/No choices and the messages several fields use.

export const COLORS = {
    DISABLED_BACKGROUND: "#ececec",
    SECTION_BORDER: "#7F8284",
    COLUMN_DIVIDER: "#e0e0e0",
    ERROR_RED: "#d32f2f",
    TEXT_BLACK: "#000000",
    CLEAR_STATUS_GRAY: "#D3D3D3",
};

export const REQUIRED_FIELD_MESSAGE = "Please fill the required field.";
export const INVALID_DATE_FORMAT_MESSAGE = "Invalid date format. Date format is dd-Mmm-yyyy.";

export const YES = { selectionItemId: "0", label: "Yes", value: true };
export const NO = { selectionItemId: "1", label: "No", value: false };
export const YES_OR_NO = [YES, NO];
export const isYes = (answer) => answer?.value === true;

// Bordered sections (Lawyer Information, Disclosure Information): the box, its title and the wrapper around each field
export const sectionContainerSx = (isDisabled) => ({
    padding: "10px 12px 20px 12px", border: `1px solid ${COLORS.SECTION_BORDER}`, margin: "10px 0px 0px 0px", borderRadius: "8px",
    backgroundColor: isDisabled ? COLORS.DISABLED_BACKGROUND : null,
});
export const SECTION_TITLE_SX = {
    textAlign: "left", font: "normal normal normal 17px/22px Franklin Gothic Medium",
    letterSpacing: "0px", color: COLORS.TEXT_BLACK, opacity: "1", marginBottom: "10px",
};
export const FIELD_SX = { m: "10px 0" };

// Body of the 4-column sections (Lawyer Information, Disclosure Information)
export const SECTION_BODY_SX = {
    display: 'flex',
    flexWrap: 'wrap',
    // Full-width overrides for all MUI form controls within this container
    '& .MuiTextField-root': { width: '100%' },
    '& .MuiOutlinedInput-root': { width: '100%' },
    '& .MuiInputBase-input': { width: '100%' },
    '& .MuiStack-root': { width: '100%' },
    '& .MuiAutocomplete-root': { width: '100%' },
    // Compact sizing for smaller screens (iPad landscape = 1024px, portrait = 768px)
    // Targets screens where 4 columns are shown but space is tight
    '@media (min-width: 900px) and (max-width: 1199px)': {
        '& .MuiInputLabel-root': { fontSize: '12px' },
        '& .MuiInputBase-input': { fontSize: '12px' },
        '& .MuiOutlinedInput-root fieldset legend': {
            fontSize: '10.5px',
            padding: '0px 6px 0px 2px',
        },
        '& .MuiInputAdornment-root': { ml: 0 },
        '& .MuiInputAdornment-root .MuiButton-root': {
            transform: 'scale(0.86)',
            transformOrigin: 'right center',
            px: '2px',
        },
        '& .MuiInputAdornment-root .MuiButton-root div': {
            fontSize: '11.2px',
        },
    },
};

// Shared column styles for the 4-column layout.
// Each column is 100% on mobile, 50% on tablet portrait, 25% on desktop/tablet landscape.
export const COLUMN_SX = {
    flexBasis: { xs: '100%', sm: '50%', md: '25%' },
    maxWidth: { xs: '100%', sm: '50%', md: '25%' },
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    px: { xs: 0, sm: 1 },
    boxSizing: 'border-box',
};

// Columns 2-4 have a left border to separate from the previous column.
// On xs (mobile), columns stack vertically with a top border instead.
export const columnWithLeftBorderSx = (showBorderAtSm = true) => ({
    ...COLUMN_SX,
    borderLeft: { xs: 'none', ...(showBorderAtSm ? { sm: `2px solid ${COLORS.COLUMN_DIVIDER}` } : { md: `2px solid ${COLORS.COLUMN_DIVIDER}` }) },
    borderTop: { xs: `2px solid ${COLORS.COLUMN_DIVIDER}`, sm: 'none' },
    pt: { xs: 1, sm: 0 },
    mt: { xs: 1, sm: 0 },
});
